import { render } from "./AcademyTeaser.vue?vue&type=template&id=4c4721c1"
import script from "./AcademyTeaser.vue?vue&type=script&lang=js"
export * from "./AcademyTeaser.vue?vue&type=script&lang=js"

import "./AcademyTeaser.vue?vue&type=style&index=0&id=4c4721c1&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__